import { type IIconProps } from './IIconProps';

interface IFileIconProps extends IIconProps {}

export default function FileIcon({ color = '#000' }: IFileIconProps) {
  return (
    <svg viewBox="0 0 18 25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2969 5.26044C17.7188 5.68231 18 6.29169 18 6.85419V22.4167C18 23.6823 16.9688 24.6667 15.75 24.6667H2.25C0.984375 24.6667 0 23.6823 0 22.4167V2.91669C0 1.69794 0.984375 0.666687 2.25 0.666687H11.8125C12.375 0.666687 12.9844 0.901062 13.4062 1.32294L17.2969 5.26044ZM15.5625 6.66669L12 3.10419V6.66669H15.5625ZM2.25 22.4167H15.75V8.91669H10.875C10.2188 8.91669 9.75 8.44794 9.75 7.79169V2.91669H2.25V22.4167Z"
        fill={color}
      />
    </svg>
  );
}
